<template>
  <div class="container" style="position: relative;">
    <div id="contact" style="position: absolute; top: -80px; left: 0"></div>
    <md-card class="customCard">
        <md-card-content>
          <h2 class="title">Kontakt</h2>
          <div class="md-layout">
            <div class="md-layout-item">
              <div>
              <span class="material-icons contactIcon">place</span>
              <h4 class="contactTitle"> Hier finden Sie uns!</h4>
            </div>
            <p>Balkon &amp; Zaun-Profi<br>Leibhammer + Rietz GmbH<br>
              Schlehenweg 5<br>73557 Mutlangen</p>
            <div style="line-height:50%;">
              <br>
            </div>
            <div>
              <span class="material-icons contactIcon">phone</span>
              <h4 class="contactTitle">Nehmen Sie Kontakt auf!</h4>
            </div>
            <p>Mobil: 0172-7108977<br>E-Mail: info@rietz.gmbh</p>
            <div style="line-height:50%;">
              <br>
            </div>
            <div>
              <h4 class="contactTitle"></h4>
            </div>
            <p></p>
            <p></p>
          </div>
          <div class="md-layout-item md-size-75">
            <div class="iframe-container">
              <iframe 
              src="https://maps.google.de/maps?hl=de&q=Leibhammer+++Rietz+GmbH%20%20Schlehenweg+5%20Mutlangen&amp;t=&amp;z=12&amp;ie=UTF8&amp;iwloc=&amp;output=embed" 
              ></iframe>
            </div>
          </div>  
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>
<script>
export default {
  props: {
    backgroundColor: String,
    type: String
  },
  data() {
    return {
    };
  }
};
</script>

